import Service from "../service";
import AuthService from "../AuthService";

const Auth = {
    login(data) {
        return Service.post("/login", data);
    },
    register(data){
        return Service.post('/register',data);
    },
    update(id, data) {
        return AuthService.post("/update/" + id, data);
    },
    getUserAll() {
        return AuthService.get("/get_user");
    },
    logout() {
        return AuthService.post("/logout");
    },
  contact(data) {
    return Service.post("/contact",data);
  },
};

export default Auth;
